<template>
    <div class="xiaofeijilu">
        <div class="tit">消费记录</div>
        <div class="zong">
            <span>总共充值:{{statistics.money}}元</span>
            <span>获得缩币:{{statistics.virtualCoin}}个</span>
            <span>消费缩币:{{statistics.consumptionCoin}} 个</span>
            <span>缩币余额:{{statistics.residueCoin}}个</span>
        </div>
        <el-form inline>
            <el-form-item label="数据作者">
                <el-input v-model="form.nickName"
                          placeholder=""
                          style="width:100px"
                          clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-select v-model="form.preType"
                           placeholder="请选择彩种"
						   clearable 
                           style="width:120px">
                    <el-option v-for="(item, index) in lottery"
                               :key="index"
                               :value="item.dictLabel"
                               :label="item.dictLabel"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-date-picker v-model="pickerTime"
                                @change="pickerChange"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>

                <el-button type='primary'
                           @click="getList">搜索</el-button>
                <el-button type='primary'
                           @click="getList">刷新</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tableData"
                  border
                  style="width: 100%"
                  :header-cell-style="{ color: '#ffffff', backgroundColor: '#2899DF', }">
            <el-table-column prop="createTime"
				width="100"
                             label="购买时间"></el-table-column>
            <el-table-column prop="productModel "
                             label="购买数据种类">
                <template slot-scope="scope">
                    <!-- {{ scope.row.productType | findLottery(lottery) }} -->
                    {{
						scope.row.productModel == '0' ? '缩水师' : 
						scope.row.productModel == '0' ? '技巧师' :  ''
					}}
                </template>
            </el-table-column>
            <el-table-column prop="productAuthor"
                             label="购买数据作者"></el-table-column>
            <el-table-column prop="preType"
                             label="购买彩种"></el-table-column>
            <el-table-column prop="number"
                             label="购买期数"></el-table-column>
            <el-table-column prop="consumptionCoin"
                             label="消费缩币"></el-table-column>
            <el-table-column prop="residueCoin"
                             label="缩币余额"></el-table-column>
        </el-table>

        <el-pagination 
						style="padding-top:20px;text-align:right"
						background
						layout="prev, pager, next"
						@current-change="changePage"
						:page-size="listPagin.limit"
						:total="listPagin.total">
		</el-pagination>

		<!-- <hxlPagin :listPagin="listPagin" @changePage="changePage"/> -->
    </div>
</template>

<script>
import hxlPagin from '@/components/hxl-pagin';
import { count, consumptionRecord } from '@/api/chongzhi';
import { queryLotteryType } from '@/api/common';
export default {
	components:{hxlPagin},
    data () {
        return {
			listPagin: {
                page: 1,
                limit: 10,
                total: 0
            },




            lottery: [],
            pickerTime: '',
            form: {
				pageNum:1,
				pageSize:10,
                nickName: null,
                preType: null,
                params: {
                    beginTime: null,
                    bendTime: null,
                },
            },
            tableData: [],
			

            statistics: {}
        }
    },
	watch:{
		pickerTime(val){
			this.form.params = !val ? {} :''
		},
		'form.productType'(val){
			console.log('!val',val);
			this.form.productType = val == '' ? null : val
		}
	},
    filters: {
        findLottery (value, lottery) {
            const obj = lottery.find(item => item.dictValue === value);
            return obj ? obj.dictLabel : null;
        }
    },
    mounted () {

        // 消费统计
        count().then(res => this.statistics = res.data)

        queryLotteryType().then(res => {
            this.lottery = res.data.map(item => JSON.parse(JSON.stringify(item, ['dictLabel', 'dictValue'])))
            this.getList()
        })

    },
    methods: {
		// 分页状态变化
        changePage (e) {
			this.form.pageNum = e
            this.listPagin.page = e
            this.getList();
        },


        getList () {
            // 消费记录
            consumptionRecord(this.form).then(res => {
				let {rows,total} = res.data
                this.tableData = rows
				this.listPagin.total = total
            })
        },
        pickerChange (e) {
            this.form.params = {
                beginTime: e[0],
                bendTime: e[1],
            }
        },
		
    }
}
</script>

<style lang="scss" scoped>
.zong {
    display: inline-block;
    margin: 0px 0 30px;
    padding: 0 50px;
    border-bottom: 5px solid #347caf;
    font-weight: bold;
    span {
        display: inline-block;
        margin: 10px;
    }
}
</style>